// ChatContext.tsx
import { createContext, useState, useContext } from "react";

interface ChatContextType {
  inputText: string;
  setInputText: (text: string) => void;
  triggerSubmit: boolean;
  setTriggerSubmit: (flag: boolean) => void;
}

const ChatContext = createContext<ChatContextType | undefined>(undefined);

export const ChatProvider = ({ children }: any) => {
  const [inputText, setInputText] = useState("");
  const [triggerSubmit, setTriggerSubmit] = useState(false);

  return (
    <ChatContext.Provider value={{ inputText, setInputText, triggerSubmit, setTriggerSubmit }}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChatContext = () => {
  const context = useContext(ChatContext);
  if (!context) throw new Error("useChatContext must be used within ChatProvider");
  return context;
};
